import React from "react";
import Nav from "../../components/Navbar/Nav";
import "./Profile.css";
import { useSelector } from "react-redux";
import { selectUser } from "./../../features/userSlice";
import { auth } from "../../firebase";

function Profile() {
	const user = useSelector(selectUser);

	return (
		<div className="profile">
			<Nav />
			<div className="profile_content">
				<h1>Edit Profile</h1>
				<div className="profile_info">
					<img
						className=""
						src="https://upload.wikimedia.org/wikipedia/commons/0/0b/Netflix-avatar.png?20201013161117"
						alt="Netflix Avatar"
					/>
					<div className="profile_details">
						<h2>{user.email}</h2>
						<div className="profile_plans">
							<h3>Plan (Current plan is: Premium)</h3>
							<button
								onClick={() => auth.signOut()}
								className="profile_signout"
							>
								Sign out
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default Profile;
